@if (printInfo$|async; as printInfo) {
  <div id="divPrintContents" class="hide" (click)="clear()">
    <div id="divLatestLabel"> {{printInfo.latestLabel}} </div>
    <div id="divLatestLabelTemplate"> {{printInfo.latestLabelTemplate}} </div>
    <div id="divLatestReceipt"> {{printInfo.latestReceipt}} </div>
    <div id="divLatestReceiptTemplate"> {{printInfo.latestReceiptTemplate}} </div>
    @if (printInfo.latestPrintLoaded) {
      <div id="divLatestPrintLoaded-{{printInfo.refreshCounter}}"></div>
    }
  </div>
}